import { defineTextStyles } from '@chakra-ui/react';
/**
 * need to add type annotation
 * @see https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1519138189
 */
export const textStyles = defineTextStyles({
    body1: {
        value: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
        },
    },
    body1Bold: {
        value: {
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
        },
    },
    body2: {
        value: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
        },
    },
    body2Bold: {
        value: {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '20px',
        },
    },
    body3: {
        value: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '18px',
        },
    },
    body3Bold: {
        value: {
            fontSize: '12px',
            fontWeight: 700,
            lineHeight: '18px',
        },
    },
    cta: {
        value: {
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
        },
    },
    overline: {
        value: {
            fontSize: '10px',
            fontWeight: 400,
            lineHeight: '12px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
        },
    },
    caption: {
        value: {
            fontSize: '10px',
            fontWeight: 700,
            lineHeight: '16px',
            letterSpacing: '0.2px',
        },
    },
});
